//
//
//
//
//
//
//
//
//
//
//
//
//

import env from './env'
import { setUserId, setUserName } from './vuex/actions.js'
import store from './vuex/store'
export default {
    store,
    mounted: function () {
        this.$nextTick(function () {
        })
    },
    provide () {
        return {
        }
    },
    data () {
        return {
            isRouterAlive: true,
            signture: {},
            loading: 0
        }
    },
    components: {
    },
    methods: {
        getUserInfo: function () {
            let that = this
            this.$http({ url: env.remoteDingtalkUrl + '/v1/user/' + that.userId, method: 'GET' }).then(function (response) {
                if (response.data.status === 'ok') {
                    console.log('获取员工信息成功，写入vuex')
                    that.setUserName(response.data.user.name)
                    that.$router.push('/home')
                } else {
                    window.alert('获取员工信息异常，可能部分功能异常！')
                }
            }, function (response) {
                // error callback
                window.alert('服务器好像走神了，请稍后再试吧！')
                console.log('err in get ques')
            })
        }
    },
    vuex: {
        actions: {
            setUserId,
            setUserName
        },
        getters: {
            employeeNumber: state => state.user.employeeNumber,
            userId: state => state.user.userId
        }
    }
}



// WEBPACK FOOTER //
// ./src/App.vue